import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CommonTable from '../../CommonTable/CommonTable';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import Link from '../../Link/Link';
import { isValidJSON } from '../../../helpers/isValidJSON';
import { GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cp from '../../../components/commonStyle.css';
import s from './ViewFailedPayout.css';
import messages from '../../../locale/jsonMessages';
class ViewFailedPayout extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,

    }

    constructor(props) {
        super(props);
    }

    thead = () => {
        const { formatMessage } = this.props.intl;
        return [
            { data: formatMessage(messages.reservationId) },
            { data: formatMessage(messages.codeLabel) },
            { data: formatMessage(messages.adminListTitle) },
            { data: formatMessage(messages.ownersName) },
            { data: formatMessage(messages.payoutLabel) },
            { data: formatMessage(messages.reason) },
        ]
    };

    tbody = (props) => {
        const { data } = props;
        const { formatMessage } = this.props.intl;
        let failedTransactionData = [], checkJSON, payoutAmount;
        payoutAmount = data.total - data.hostServiceFee;

        if (data && data.hostFailedTransaction) failedTransactionData.push(data.hostFailedTransaction)
        if (data && data.claimFailedTransaction) failedTransactionData.push(data.claimFailedTransaction)

        return failedTransactionData?.map((item, key) => {
            checkJSON = isValidJSON(item.reason);
            let reason = checkJSON ? JSON.parse(item.reason) : item.reason;

            return {
                id: key,
                data: [
                    { data: data.id },
                    { data: data.confirmationCode },
                    {
                        data: data?.listData ? <div><a href={"/cars/" + data.listId} target='_blank'>
                            {data.listData.title}
                        </a></div> : <p>{formatMessage(messages.dataMissing)}</p>
                    },
                    { data: data?.hostData?.firstName },
                    {
                        data: item.payoutType == 'claimPayout' ?
                            <CurrencyConverter amount={data.claimPayout} from={data.currency} /> :
                            <> {payoutAmount > 0 && <CurrencyConverter amount={payoutAmount} from={data.currency} />}</>
                    },
                    { data: reason?.raw?.message ? reason?.raw?.message : item.reason }
                ]
            }
        })
    }

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <h1 className='siteAdminHeading'>{formatMessage(messages.failedPayout)}</h1>
                <div className={cx('singleBtnFlexEnd', cp.spaceBottom4)}>
                    <Link to={'/siteadmin/payout'} className='goBackLink'>
                        <GoBackArrow />
                        <FormattedMessage  {...messages.goBack} />
                    </Link>
                </div>
                <CommonTable
                    thead={this.thead}
                    tbody={() => this.tbody(this.props)}
                    isHeadingHide
                />
            </div>
        )
    }
}

export default injectIntl(withStyles(cp, s)(ViewFailedPayout));